import { debounce } from 'lodash'
import { loadOptions } from '../components/routes/functions/loadMapboxAddresses'

export const asyncSelectConfig = {
    routeStopsConfig: {
        name: 'search-locations--stop',
        loadOptions: debounce(loadOptions, 250),
        classNamePrefix: 'chakra-react-select',
        placeholder: 'Enter Destination',
        closeMenuOnSelect: true,
        instanceId: `search-locations--stop`,
        cacheOptions: true,
        useBasicStyles: true,
        chakraStyles: {
            container: (provided) => ({
                ...provided,
                cursor: 'pointer',
                width: 'full',
            }),
            singleValue: (provided) => ({
                ...provided,
                pl: 2,
            }),
            valueContainer: (provided) => ({
                ...provided,
                pl: 0,
                py: 0,
            }),
            input: (provided) => ({
                ...provided,
                pl: 2,
            }),
            inputContainer: (provided) => ({
                ...provided,
                maxW: { base: 'full', lg: '15rem' },
                py: 0,
            }),
        },
    },
    addStopConfig: {
        name: 'search-locations--add-stop',
        loadOptions: debounce(loadOptions, 250),
        classNamePrefix: 'chakra-react-select',
        placeholder: 'Enter Destination',
        closeMenuOnSelect: true,
        instanceId: `search-locations--add-stop`,
        cacheOptions: true,
        chakraStyles: {
            container: (provided) => ({
                ...provided,
                cursor: 'pointer',
                width: 'full',
                mt: 2,
                ml: 4,
            }),
            singleValue: (provided) => ({
                ...provided,
                pl: 2,
            }),
            valueContainer: (provided) => ({
                ...provided,
                pl: 0,
                py: 0,
            }),
            placeholder: (provided) => ({
                ...provided,
                pl: 2,
            }),
            inputContainer: (provided) => ({
                ...provided,
                maxW: { base: 'full', lg: '15rem' },
                py: 0,
                pl: 2,
            }),
        },
    },
    breweriesForYouConfig: {
        name: 'search-locations--breweries-for-you',
        loadOptions: debounce(loadOptions, 250),
        classNamePrefix: 'chakra-react-select',
        placeholder: 'Search for breweries, cities or venues',
        closeMenuOnSelect: true,
        instanceId: `search-locations--breweries-for-you`,
        cacheOptions: true,
        chakraStyles: {
            valueContainer: (provided) => ({
                ...provided,
                py: 0,
            }),

            inputContainer: (provided) => ({
                ...provided,
                py: 0,
                maxW: { base: 'full', lg: '15rem' },
            }),
            input: (provided) => ({
                ...provided,
                minW: '15rem',
            }),
        },
    },
}
